import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "15",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#fff",
      "stroke-width": "1.5",
      d: "M5 7.53c0-1.664 0-2.496.469-3.013S6.692 4 8.2 4h1.6c1.508 0 2.263 0 2.731.517C13 5.034 13 5.866 13 7.53v2.942c0 1.663 0 2.496-.469 3.012C12.063 14 11.308 14 9.8 14H8.2c-1.508 0-2.263 0-2.731-.517C5 12.966 5 12.134 5 10.47z"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#fff",
      "stroke-width": "1.5",
      d: "M10.333 3.27v-.525A1.745 1.745 0 0 0 8.588 1H6.26c-2.194 0-3.29 0-3.972.682-.682.68-.682 1.778-.682 3.972v3.49a1.745 1.745 0 0 0 1.746 1.745h.88"
    }, null, -1)
  ])))
}
export default { render: render }